import React, { useState } from 'react';
import { post } from '.././helpers/api_helper';
import { useLocation , useNavigate} from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader";
import { toast, ToastContainer } from 'react-toastify';

export default function Referral() {
  const navigate = useNavigate();
  const location = useLocation();
  const productId = new URLSearchParams(location.search).get('productId');
  const [mobileNumber, setMobileNumber] = useState('');
  const [loading, setIsLoading] = useState(false)

  const handleShareProduct = async () => {
    try {
      setIsLoading(true)
      const response = await post('/shareProduct', { shareProductId: productId, mobile: mobileNumber });
      const updateLinks = response.updateLinks;
      toast.success("Product Shared Successfully")
      setIsLoading(false)
      navigate(`/share?updateLinks=${updateLinks}`);

    } catch (error) {
      toast.error('Error sharing product');
    }
  };

  return (
    <>
    <ToastContainer/>
    <div className="mt-16 mx-auto w-fit md:max-w-screen-xl px-10 py-16 shadow-xl mb-6">
      <h1 className="text-2xl font-semibold mb-4 ">Share Product</h1>
      <div className="mb-4 ">
        <label htmlFor="mobileNumber" className="block text-gray-600 dark:text-gray-400">
          Recipient's Mobile Number
        </label>
        <input
          type="text"
          id="mobileNumber"
          name="mobileNumber"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          placeholder="Enter mobile number"
          className="border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 w-full"
        />
      </div>
      <button
        type="button"
        onClick={handleShareProduct}
        className="text-white bg-[#6c757d] hover:bg-[#6c757d]/80 focus:ring-2 focus:outline-none focus:ring-[#6c757d]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600"
      >
        {loading?(
          <div  className='px-4'>
            <ClipLoader size={22} color='white'/>
          </div>
        ):(
          <span>
            Share Now
          </span>
        )}
        
      </button>
    </div>
    </>
  );
}
